import React from "react";
import { Link } from "react-router-dom";

function Slider1({ setTab }) {
  return (
    <div className="image-container" id="slider1">
      <div className="overlay"></div>
      <div className="image-half">
        <img
          src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/bg-image/girl.jpg"
          alt="girl"
        />
      </div>
      <div className="content">
        <span className="heading1">We Bring</span>
        <br />
        <span className="heading2">
          For Your <span style={{ color: "#12b48b" }}>Eyes</span> Only
        </span>
        <br />
        <p className="para">
          Placing you and your safety at the heart of everything
        </p>
        <Link
          to="/appointment"
          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top15"
          onClick={() => setTab("appointment")}
        >
          Book Appointment
        </Link>
      </div>
    </div>
  );
}

export default Slider1;
